export const GifIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <g clipPath="url(#clip0_1984_7784)">
      <path
        d="M4.96484 2.1125L5.78047 3.5H5.75H4.0625C3.54453 3.5 3.125 3.08047 3.125 2.5625C3.125 2.04453 3.54453 1.625 4.0625 1.625H4.11406C4.46328 1.625 4.78906 1.81016 4.96484 2.1125ZM2 2.5625C2 2.9 2.08203 3.21875 2.225 3.5H1.25C0.835156 3.5 0.5 3.83516 0.5 4.25V5.75C0.5 6.16484 0.835156 6.5 1.25 6.5H11.75C12.1648 6.5 12.5 6.16484 12.5 5.75V4.25C12.5 3.83516 12.1648 3.5 11.75 3.5H10.775C10.918 3.21875 11 2.9 11 2.5625C11 1.42344 10.0766 0.5 8.9375 0.5H8.88594C8.13828 0.5 7.44453 0.896094 7.06484 1.54063L6.5 2.50391L5.93516 1.54297C5.55547 0.896094 4.86172 0.5 4.11406 0.5H4.0625C2.92344 0.5 2 1.42344 2 2.5625ZM9.875 2.5625C9.875 3.08047 9.45547 3.5 8.9375 3.5H7.25H7.21953L8.03516 2.1125C8.21328 1.81016 8.53672 1.625 8.88594 1.625H8.9375C9.45547 1.625 9.875 2.04453 9.875 2.5625ZM1.25 7.25V11.375C1.25 11.9961 1.75391 12.5 2.375 12.5H5.75V7.25H1.25ZM7.25 12.5H10.625C11.2461 12.5 11.75 11.9961 11.75 11.375V7.25H7.25V12.5Z"
        fill="#3730A3"
      />
    </g>
    <defs>
      <clipPath id="clip0_1984_7784">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
